<div class="login">
  <div class="login-wrapper">
    <form autocomplete="off" [formGroup]="form" (submit)="send()">
      <div class="header-form">
        <div class="logo-box">
          <img src="assets/img/logo-mini.svg" class="logo" alt="">
        </div>
        <div class="header-form__caption">
          <div class="title">Обращение в СвояСвязь</div>
          <div class="caption">Возможно ответ на ваш вопрос есть в разделе <a routerLink="/help"><strong>Инструкции</strong></a></div>
        </div>
      </div>
      <div class="field-list" *ngIf="!isSend">
        <div class="field">
          <div class="caption">Тема обращения</div>
          <div class="field-input">
            <ui-input type="text" [disabled]="processing" placeholder="Тема обращения" formControlName="subject"></ui-input>
          </div>
        </div>
        <div class="field">
          <div class="caption">Обращение</div>
          <div class="field-input">
            <ui-input type="text" [disabled]="processing" [isTextarea]="true" [rows]="8" placeholder="Описание" formControlName="message" class="chat-actions__input"></ui-input>
          </div>
        </div>
      </div>
      <div *ngIf="isSend">
        <p>Обращение успешно отправлено!</p>
        <a routerLink="/">Вернуться на главную</a>
      </div>
      <button nz-button nzType="primary" [disabled]="processing" *ngIf="!isSend" type="submit">Отправить</button>
      <div class="error error-server" *ngIf="serverError">{{this.serverError}}</div>
    </form>
  </div>
</div>
